import React from 'react';
import { Badge, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { BellIcon } from '../Navbar/Icons';
import { UserRole } from '@/types';
import './UIBell.scss';

interface UIBellProps {
  notificationsCount: number;
  role: UserRole | null;
}

const UIBell: React.FC<UIBellProps> = ({ notificationsCount, role }) => {
  const navigate = useNavigate();

  const handleBellClick = () => {
    if (role === UserRole.OWNER) {
      navigate('/dashboard/notifications');
    } else if (role === UserRole.TENANT) {
      navigate('/notifications');
    }
  };

  return (
    <IconButton className="bell-icon" onClick={handleBellClick}>
      {notificationsCount > 0 ? (
        <Badge
          badgeContent={notificationsCount}
          color="error"
          className="bell-icon__badge"
        >
          <BellIcon />
        </Badge>
      ) : (
        <BellIcon />
      )}
    </IconButton>
  );
};

export default UIBell;
